import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";

const IpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: white;
  text-shadow: -1px 0 black, 0 1px black, 1px 0 black, 0 -1px black;
  padding: 5px 15px;
`;

const IpInfo = () => {
  const [pubIp, setPubIp] = useState("");

  function getIP() {
    // TODO: Bryt ut api call
    fetch("https://api.ipify.org?format=json").then(response => {
      response.json().then(data => {
        setPubIp(data.ip);
      });
    });
  }
  useEffect(() => {
    getIP();
  }, []);
  return <IpContainer>{pubIp}</IpContainer>;
};

export default IpInfo;
